import React from 'react';
import { IconButton, Theme, Typography } from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';
import clsx from 'clsx';
import { CustomIcon, Translation } from '@troy/shared/src/components/common';

export const getCloseButtonId = (id: string): string => `${id}-close`;

const useStyles = makeStyles((theme: Theme) => ({
  root: {
    width: '100%',
    maxWidth: '300px',
    display: 'flex',
    flexDirection: 'row',
    padding: theme.spacing(2),
    borderRadius: Number(theme.shape.borderRadius) * 4,
    boxSizing: 'border-box'
  },
  error: {
    background: theme.palette.warning.dark
  },
  content: {
    display: 'flex',
    flexDirection: 'column',
    color: theme.palette.primary.contrastText,
    margin: `0 ${theme.spacing(1)}`
  },
  closeButton: {
    margin: 'auto 0 auto auto',
    padding: theme.spacing(0.5)
  }
}));

interface AlertProps {
  id: string;
  className?: string;
  type: 'error'; // | 'warning' | 'sucess';
  title: string;
  onCloseClick: () => void;
  children: React.ReactNode;
}

// ************
// TODO fix warning and success styles when needed
// ************

const Alert: React.FC<AlertProps> = ({
  id,
  className,
  type,
  title,
  onCloseClick,
  children
}): React.ReactElement => {
  const classes = useStyles();

  return (
    <div
      role="alert"
      id={id}
      className={clsx(classes.root, classes[type], className)}
    >
      <CustomIcon icon="alert" size="small" variant="light" />
      <div className={classes.content}>
        <Typography component="h3" variant="body1">
          <Translation isFragment keyIfNoValue>
            {title}
          </Translation>
        </Typography>
        {children}
      </div>
      <IconButton
        id={getCloseButtonId(id)}
        className={classes.closeButton}
        onClick={onCloseClick}
        size="large"
      >
        <CustomIcon size="small" icon="dismiss" variant="light" />
      </IconButton>
    </div>
  );
};

export default Alert;
